import React from 'react';
import FormInventoryDetailSection from '../../../sections/AdminDashboard/FormInventory/FormInventoryDetail';

const FormInventoryDetail = () => <FormInventoryDetailSection />;

export default FormInventoryDetail;
